import React from 'react';
import parse from 'react-html-parser';
import DOMPurify from 'dompurify';

type ParseContentProps = { content?: string | null };

const ParseContent: React.FC<ParseContentProps> = ({ content }) => {
	return <>{content && parse(DOMPurify.sanitize(content))}</>;
};

export default ParseContent;
